import { render, staticRenderFns } from "./ZbDynamicCommentList.vue?vue&type=template&id=f13adb60"
import script from "./ZbDynamicCommentList.vue?vue&type=script&lang=js"
export * from "./ZbDynamicCommentList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports